/**
 * @description Class used to deal with all non-httpOnly cookies
 */
export default class CookieParser {
    /**
     * @description Takes all non-httpOnly cookies, converts them into an object, and returns them
     * @returns {Object} cookies
     */
    static get cookies() {
        const cookies = {}
        document.cookie
            .split(/;\s*/g)
            .filter(_ => _)
            .forEach(part => {
                const eq = part.indexOf('=')
                if (eq === -1) return
                const key = part.slice(0, eq).trim()
                const value = part.slice(eq + 1)
                cookies[key] = value
            })
        return cookies
    }

    /**
     * @description Takes an object and adds each key/value pair to document.cookie
     * @param {Object} obj
     */
    static setCookies(obj) {
        for (const key in obj) {
            if (typeof obj[key] !== 'string') {
                obj[key] = JSON.stringify(obj[key])
            }
            document.cookie = `${key}=${obj[key]};path=/`
        }        
    }

    /**
     * @description Deletes cookie by setting early expire date
     * @param {String} cookieName
     */
    static deleteCookie(cookieName) {
        document.cookie = `${cookieName}=;expires=${new Date(0).toUTCString()}`
    }
}
